module.exports = __webpack_public_path__ + "img/067-cloudy-night.8fc61191.svg";